<template>
    <ToggleGrid/>
    <GetHeroNavigation :show-home-button="true" />
    <div v-if="checkPath" class="profile-hero">
        <UserThemeCoverImage v-if="templateSettings.showProfilePicture" />
        <div class="profile-bio">
            <UserPortfolioDescription />
        </div>
    </div>
</template>

<script>
    import UserThemeCoverImage from "../../common/user/UserThemeCoverImage.vue";
    import UserPortfolioDescription from "../../common/user/UserPortfolioDescription.vue";
    import ToggleGrid from "../../../../common/components/ToggleGrid.vue";
    import GetHeroNavigation from "../../common/hero/GetHeroNavigation.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "ProfileThemeEight",
        components: {
            GetHeroNavigation,
            ToggleGrid,
            UserPortfolioDescription,
            UserThemeCoverImage,
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            portfolio() {
                return this.viewData.portfolio
            },
            templateSettings() {
                return this.viewData.portfolio.templateSettings
            },
            checkPath() {
                return !window.location.pathname.includes('/p/') &&
                    !window.location.pathname.includes('/about') &&
                    !window.location.pathname.includes('/contact')
            }
        }
    }
</script>